import { SweetAlertOptions, SweetAlertResult } from 'sweetalert2';
import { makeStyles, Theme } from '@material-ui/core/styles';
import getBaseSweetAlert from './get-base-sweet-alert';
import { SweetAlertHookApi } from 'types';

const useStyles = makeStyles((theme: Theme) => ({
  title: {
    ...theme.typography.h2
  },
  container: {
    zIndex: theme.zIndex.modal + 1
  },
  content: {
    ...theme.typography.body1,
    marginTop: theme.spacing(2),
    fontWeight: 300,
    fontSize: '1.125em'
  },
  popup: {
    width: '28em',
    borderRadius: '8px'
  },
  confirmButton: {
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.pxToRem(16),
    lineHeight: theme.typography.pxToRem(21),
    backgroundColor: `${theme.palette.primary.main} !important`,
    borderRadius: '24px !important',
    height: 43,
    width: 138
  },
  alertCancelButton: {
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.pxToRem(16),
    lineHeight: theme.typography.pxToRem(21),
    backgroundColor: `${theme.palette.common.white} !important`,
    color: `${theme.palette.grey[800]} !important`,
    border: `solid 1px ${theme.palette.grey[500]} !important`,
    padding: `${theme.spacing(1.375)}px ${theme.spacing(3.5)}px`,
    borderRadius: '24px !important',
    height: 43
  }
}));

const useSuccessAlert = (): SweetAlertHookApi => {
  const classes = useStyles();
  const SweetAlert = getBaseSweetAlert({
    icon: 'success',
    showConfirmButton: true,
    showCloseButton: false,
    showCancelButton: false,
    customClass: {
      title: classes.title,
      container: classes.container,
      content: classes.content,
      popup: classes.popup,
      confirmButton: classes.confirmButton,
      cancelButton: classes.alertCancelButton
    }
  });

  const open = (options?: SweetAlertOptions): Promise<SweetAlertResult> => {
    return SweetAlert.fire({
      ...options
    });
  };

  return {
    open
  };
};

export default useSuccessAlert;
